import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=2166843c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=2166843c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2166843c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2166843c')) {
      api.createRecord('2166843c', component.options)
    } else {
      api.reload('2166843c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=2166843c&scoped=true&", function () {
      api.rerender('2166843c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bcd0yu2ryi1i/JS/comp/Voucher.vue"
export default component.exports